/**
 * 收款管理
 */
import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/finance/collectionmanage/model';
import TableList from './components/TableList';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { TableActionType as ta } from '@/util/enum';
import CollectionModal from '../modal/CollectionModal';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { message } from 'antd';

class Main extends React.Component {

    state = {
        collectionId: undefined,
        companyName: undefined,
        startTime: undefined,
        endTime: undefined,
        pageNum: 1,
        pageSize: 10,
        selectedKeys: [],
        openModeParam: {},
        currentOpenMode: ''
    }

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match);
    }

    // 查询
    _searchHandle = (useCache) => {
        const { collectionId, companyName, startTime, endTime, pageNum, pageSize } = this.state;

        this.searchCache = {
            receiptId: collectionId,
            payCompanyName: companyName,
            receiveStartTime: startTime,
            receiveEndTime: endTime,

            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getTableSource(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => this._searchHandle('useCache'));
    }

    // 重置
    _resetHandle = () => {
        this.setState({ collectionId: undefined, companyName: undefined, startTime: undefined, endTime: undefined, pageNum: 1, pageSize: 10 }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 关闭弹框
    _closeMode = (reload) => {
        this.setState({ currentOpenMode: '', openModeParam: {} });
        reload && this._searchHandle();
    }

    // 表格操作
    _tableAction = (key, type, item) => {
        switch (type) {
            case ta.detail:
                this.props.history.push({ pathname: `/home/finance/collectionmanage/detail/${key}` });
                break;
            case ta.edit:
                this.setState({ currentOpenMode: ta.edit, openModeParam: { id: key } });
                break;
            case ta.sure:
                http('/?cmd=com.xqxc.api.pig.mis.settle.SettleReceiptApiMisService.confirmReceipt', { receiptId: key }, 'POST').then((res) => {
                    let msg = res.message;
                    if (res.errCode === 0) {
                        msg = '操作成功';
                        this._searchHandle('useCache');
                    }
                    message.success(msg);
                }).catch((reject = {}) => message.error(reject.message));
                break;
        }
    }

    // 新建收款单
    _newHandle = () => {
        this.setState({ currentOpenMode: ta.create, openModeParam: {} });
    }

    // 打开弹窗  
    _renderMode = () => {
        switch (this.state.currentOpenMode) {
            case ta.create:
                return <CollectionModal title='新建收款单' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            case ta.edit:
                return <CollectionModal title='编辑收款单' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }

    render() {
        const { collectionId, companyName, startTime, endTime } = this.state;
        let { curTabID, tableSource } = this.props;

        return (
            <KeepAlive id={curTabID} render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='收款单号'
                                placeholder='请输入'
                                value={collectionId}
                                bindThis={this}
                                bindName='collectionId'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                inputStyle={{ width: 200 }}
                                label='企业名称'
                                placeholder='请输入'
                                value={companyName}
                                bindThis={this}
                                bindName='companyName'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='收款日期'
                                datePickerStyle={{ width: 160 }}
                                value={startTime}
                                bindThis={this}
                                bindName='startTime'
                                showTime={false}
                                defaultTime='00:00:00'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                datePickerStyle={{ width: 160 }}
                                label=''
                                value={endTime}
                                bindThis={this}
                                bindName='endTime'
                                showTime={false}
                                defaultTime='23:59:59'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                style={{ marginLeft: '20px', width: '60px' }}
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: '120px' }}
                            label='新建收款单'
                            onClick={this._newHandle}
                        />
                    </div>
                    <TableList renderData={tableSource} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
                {this._renderMode()}
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object,
    curTabID: PropTypes.string,

    getTableSource: PropTypes.func,
    tableSource: PropTypes.object,
};
const mapStateToProps = (state) => ({
    tableSource: state.collectionmanage.tableSource,
});

export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions })(Main);